import { render, staticRenderFns } from "./TreeViewer.vue?vue&type=template&id=a4de0c8e&scoped=true"
import script from "./TreeViewer.vue?vue&type=script&lang=js"
export * from "./TreeViewer.vue?vue&type=script&lang=js"
import style0 from "./TreeViewer.vue?vue&type=style&index=0&id=a4de0c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4de0c8e",
  null
  
)

export default component.exports